import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import LeftSideNavigation from "../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { TopTextReusableComponent } from "../../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import Form from "react-bootstrap/Form";
import { HealthAndSenitationProtocol } from "./InsideComponent/HealthAndSenitationProtocol";
import { HealthAndSenitationOthers } from "./InsideComponent/HealthAndSenitationOthers";
import { HealthAndSenitationOthersTwo } from "./InsideComponent/HealthAndSenitationOthersTwo";
import { HealthAndSenitationOthersThree } from "./InsideComponent/HealthAndSenitationOthersThree";
import { HealthAndSenitationOthersFour } from "./InsideComponent/HealthAndSenitationOthersFour";
import { HealthAndSenitationOthersFive } from "./InsideComponent/HealthAndSenitationOthersFive";
import isEmpty from "../../../../../store/validation/is-Empty";
import { SuperAdminHASHomeScreen } from "./SuperAdminHASHomeScreen";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { clear_all_errors } from "../../../../../store/actions/errorActions";
import { superadmin_create_and_update_restaurant } from "../../../../../store/actions/SuperAdminActions/adminNewVendorOnboard";
import { AmealioLoader } from "../../../../Loader/AmealioLoader";

export class SuperAdminVendorHealthAndSenitation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vendor_id: "",
      actionButton: false,
      loader: false,
      hasSetMapProps: false,
      selectedTab: 2,
      healthAndSanitizeSwitchValue: false,
      healthAndSanitizeEntryPointCheck: true,
      healthAndSanitizeFacilityCheck: true,
      healthAndSanitizeServicesCheck: true,
      healthAndSanitizeEmployeesCheck: true,
      healthAndSanitizePracticesCheck: true,
      healthAndSanitizeProtocolCheck: true,
      selectedPage: 1,
      discription: "",
      healthandsanitization_entrypoint: [],
      healthandsanitization_facility: [],
      healthandsanitization_employees: [],
      healthandsanitization_food_handling: [],
      healthandsanitization_health_safety: [],
      // DATA
      selected_health_and_sanitization_entrypoint: [],
      selected_health_and_sanitization_facility: [],
      selected_health_and_sanitization_employees: [],
      selected_health_and_sanitization_food_handling: [],
      selected_health_and_sanitization_health_safety: [],
      primary_health_and_sanitization_entrypoint: {},
      primary_health_and_sanitization_facility: {},
      primary_health_and_sanitization_employees: {},
      primary_health_and_sanitization_food_handling: {},
      primary_health_and_sanitization_health_safety: {},
      errors: [],
      formShow: false,
    };
    // this.handleHealthAndSanitizeSwitchValue = this.handleHealthAndSanitizeSwitchValue.bind(
    //   this
    // );
  }

  // componentDidMount() {
  //   if (
  //     this.props.location.state !== null &&
  //     this.props.location.state !== undefined
  //   ) {
  //     if (this.props.location.state.data) {
  //       this.setState({
  //         healthAndSanitizeSwitchValue: this.props.location.state.returnData
  //           .healthdata,
  //         selectedPage: this.props.location.state.returnData.selectedPage,
  //       });
  //     }
  //   }
  // }

  componentDidMount() {
    let adminVendorId = this.props?.editDataAction
      ? this.props?.editData?.vendor_id
      : JSON.parse(localStorage.getItem("vendorId"));
    const formData = {
      vendor_id: adminVendorId,
    };
    if (adminVendorId !== null || adminVendorId !== undefined) {
      this.props.superadmin_create_and_update_restaurant(formData);
      this.setState({
        vendor_id: formData.vendor_id,
      });
    }
    if (this.props.auth.loader) {
      this.setState({
        loader: true,
      });
    }
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    let onboarding = nextProps?.editDataAction
      ? nextProps?.editData
      : nextProps?.onboardingData;
    if (
      !isEmpty(onboarding?._id) &&
      !isEmpty(nextProps.health_entry_point) &&
      !isEmpty(nextProps.health_inside_facility) &&
      !isEmpty(nextProps.health_employees) &&
      !isEmpty(nextProps.health_handling) &&
      !isEmpty(nextProps.heath_and_safety) &&
      !nextState.hasSetMapProps
    ) {
      let selected_health_and_sanitization_entrypoint =
        onboarding?.selected_health_and_sanitization_entrypoint;
      let selected_health_and_sanitization_facility =
        onboarding?.selected_health_and_sanitization_facility;
      let selected_health_and_sanitization_employees =
        onboarding?.selected_health_and_sanitization_employees;
      let selected_health_and_sanitization_food_handling =
        onboarding?.selected_health_and_sanitization_food_handling;
      let selected_health_and_sanitization_health_safety =
        onboarding?.selected_health_and_sanitization_health_safety;
      let primary_health_and_sanitization_entrypoint =
        onboarding?.primary_health_and_sanitization_entrypoint;
      let primary_health_and_sanitization_facility =
        onboarding?.primary_health_and_sanitization_facility;
      let primary_health_and_sanitization_employees =
        onboarding?.primary_health_and_sanitization_employees;
      let primary_health_and_sanitization_food_handling =
        onboarding?.primary_health_and_sanitization_food_handling;
      let primary_health_and_sanitization_health_safety =
        onboarding?.primary_health_and_sanitization_health_safety;

      if (
        !isEmpty(onboarding?.primary_health_and_sanitization_entrypoint) &&
        !isEmpty(onboarding?.primary_health_and_sanitization_facility) &&
        !isEmpty(onboarding?.primary_health_and_sanitization_employees) &&
        !isEmpty(onboarding?.primary_health_and_sanitization_food_handling) &&
        !isEmpty(onboarding?.primary_health_and_sanitization_health_safety) &&
        !isEmpty(selected_health_and_sanitization_entrypoint[0]) &&
        !isEmpty(selected_health_and_sanitization_facility[0]) &&
        !isEmpty(selected_health_and_sanitization_employees[0]) &&
        !isEmpty(selected_health_and_sanitization_food_handling[0]) &&
        !isEmpty(selected_health_and_sanitization_health_safety[0])
      ) {
        if (
          !isEmpty(onboarding?.primary_health_and_sanitization_entrypoint) &&
          !isEmpty(onboarding?.primary_health_and_sanitization_facility) &&
          !isEmpty(onboarding?.primary_health_and_sanitization_employees) &&
          !isEmpty(onboarding?.primary_health_and_sanitization_food_handling) &&
          !isEmpty(onboarding?.primary_health_and_sanitization_health_safety) &&
          isEmpty(selected_health_and_sanitization_entrypoint[0]._id) &&
          isEmpty(selected_health_and_sanitization_facility[0]._id) &&
          isEmpty(selected_health_and_sanitization_employees[0]._id) &&
          isEmpty(selected_health_and_sanitization_food_handling[0]._id) &&
          isEmpty(selected_health_and_sanitization_health_safety[0]._id) &&
          selected_health_and_sanitization_entrypoint.length > 0 &&
          selected_health_and_sanitization_facility.length > 0 &&
          selected_health_and_sanitization_employees.length > 0 &&
          selected_health_and_sanitization_food_handling.length > 0 &&
          selected_health_and_sanitization_health_safety.length > 0 &&
          isEmpty(primary_health_and_sanitization_entrypoint._id) &&
          isEmpty(primary_health_and_sanitization_facility._id) &&
          isEmpty(primary_health_and_sanitization_employees._id) &&
          isEmpty(primary_health_and_sanitization_food_handling._id) &&
          isEmpty(primary_health_and_sanitization_health_safety._id)
        ) {
          selected_health_and_sanitization_entrypoint =
            nextProps.health_entry_point.filter((data) =>
              selected_health_and_sanitization_entrypoint.includes(data._id)
            );
          selected_health_and_sanitization_facility =
            nextProps.health_inside_facility.filter((data) =>
              selected_health_and_sanitization_facility.includes(data._id)
            );
          selected_health_and_sanitization_employees =
            nextProps.health_employees.filter((data) =>
              selected_health_and_sanitization_employees.includes(data._id)
            );
          selected_health_and_sanitization_food_handling =
            nextProps.health_handling.filter((data) =>
              selected_health_and_sanitization_food_handling.includes(data._id)
            );
          selected_health_and_sanitization_health_safety =
            nextProps.heath_and_safety.filter((data) =>
              selected_health_and_sanitization_health_safety.includes(data._id)
            );

          primary_health_and_sanitization_entrypoint =
            nextProps.health_entry_point.filter(
              (data) => data._id === primary_health_and_sanitization_entrypoint
            )[0];
          primary_health_and_sanitization_facility =
            nextProps.health_inside_facility.filter(
              (data) => data._id === primary_health_and_sanitization_facility
            )[0];
          primary_health_and_sanitization_employees =
            nextProps.health_employees.filter(
              (data) => data._id === primary_health_and_sanitization_employees
            )[0];
          primary_health_and_sanitization_food_handling =
            nextProps.health_handling.filter(
              (data) =>
                data._id === primary_health_and_sanitization_food_handling
            )[0];
          primary_health_and_sanitization_health_safety =
            nextProps.heath_and_safety.filter(
              (data) =>
                data._id === primary_health_and_sanitization_health_safety
            )[0];
        }
      }
      let all_healthandsanitization_entrypoint =
        nextProps.health_entry_point.filter(
          (point) =>
            !selected_health_and_sanitization_entrypoint.some(
              (selected) => selected._id === point._id
            ) && point.status !== "NOTAPPROVED"
        );
      let all_healthandsanitization_facility =
        nextProps.health_inside_facility.filter(
          (point) =>
            !selected_health_and_sanitization_facility.some(
              (selected) => selected._id === point._id
            ) && point.status !== "NOTAPPROVED"
        );
      let all_healthandsanitization_employees =
        nextProps.health_employees.filter(
          (point) =>
            !selected_health_and_sanitization_employees.some(
              (selected) => selected._id === point._id
            ) && point.status !== "NOTAPPROVED"
        );
      let all_healthandsanitization_food_handling =
        nextProps.health_handling.filter(
          (point) =>
            !selected_health_and_sanitization_food_handling.some(
              (selected) => selected._id === point._id
            ) && point.status !== "NOTAPPROVED"
        );
      let all_healthandsanitization_health_safety =
        nextProps.heath_and_safety.filter(
          (point) =>
            !selected_health_and_sanitization_health_safety.some(
              (selected) => selected._id === point._id
            ) && point.status !== "NOTAPPROVED"
        );

      return {
        selected_health_and_sanitization_entrypoint: !isEmpty(
          selected_health_and_sanitization_entrypoint
        )
          ? selected_health_and_sanitization_entrypoint
          : [],
        selected_health_and_sanitization_facility: !isEmpty(
          selected_health_and_sanitization_facility
        )
          ? selected_health_and_sanitization_facility
          : [],
        selected_health_and_sanitization_employees: !isEmpty(
          selected_health_and_sanitization_employees
        )
          ? selected_health_and_sanitization_employees
          : [],
        selected_health_and_sanitization_food_handling: !isEmpty(
          selected_health_and_sanitization_food_handling
        )
          ? selected_health_and_sanitization_food_handling
          : [],
        selected_health_and_sanitization_health_safety: !isEmpty(
          selected_health_and_sanitization_health_safety
        )
          ? selected_health_and_sanitization_health_safety
          : [],
        primary_health_and_sanitization_entrypoint: !isEmpty(
          primary_health_and_sanitization_entrypoint
        )
          ? primary_health_and_sanitization_entrypoint
          : {},
        primary_health_and_sanitization_facility: !isEmpty(
          primary_health_and_sanitization_facility
        )
          ? primary_health_and_sanitization_facility
          : {},
        primary_health_and_sanitization_employees: !isEmpty(
          primary_health_and_sanitization_employees
        )
          ? primary_health_and_sanitization_employees
          : {},
        primary_health_and_sanitization_food_handling: !isEmpty(
          primary_health_and_sanitization_food_handling
        )
          ? primary_health_and_sanitization_food_handling
          : {},
        primary_health_and_sanitization_health_safety: !isEmpty(
          primary_health_and_sanitization_health_safety
        )
          ? primary_health_and_sanitization_health_safety
          : {},

        discription: onboarding?.discription,
        healthAndSanitizeSwitchValue: onboarding?.healthAndSanitizeSwitchValue,
        healthAndSanitizeEntryPointCheck: !isEmpty(
          onboarding?.healthAndSanitizeEntryPointCheck
        )
          ? onboarding?.healthAndSanitizeEntryPointCheck
          : true,
        healthAndSanitizeFacilityCheck: !isEmpty(
          onboarding?.healthAndSanitizeFacilityCheck
        )
          ? onboarding?.healthAndSanitizeFacilityCheck
          : true,
        healthAndSanitizeServicesCheck: !isEmpty(
          onboarding?.healthAndSanitizeServicesCheck
        )
          ? onboarding?.healthAndSanitizeServicesCheck
          : true,
        healthAndSanitizeEmployeesCheck: !isEmpty(
          onboarding?.healthAndSanitizeEmployeesCheck
        )
          ? onboarding?.healthAndSanitizeEmployeesCheck
          : true,
        healthAndSanitizePracticesCheck: !isEmpty(
          onboarding?.healthAndSanitizePracticesCheck
        )
          ? onboarding?.healthAndSanitizePracticesCheck
          : true,
        healthAndSanitizeProtocolCheck: !isEmpty(
          onboarding?.healthAndSanitizeProtocolCheck
        )
          ? onboarding?.healthAndSanitizeProtocolCheck
          : true,
        healthandsanitization_entrypoint: all_healthandsanitization_entrypoint,
        healthandsanitization_facility: all_healthandsanitization_facility,
        healthandsanitization_employees: all_healthandsanitization_employees,
        healthandsanitization_food_handling:
          all_healthandsanitization_food_handling,
        healthandsanitization_health_safety:
          all_healthandsanitization_health_safety,
        selectedPage: !isEmpty(onboarding?.selectedPage)
          ? onboarding?.selectedPage
          : 1,
        hasSetMapProps: true,
      };
    }
    if (nextProps?.auth?.loader !== nextState.loader) {
      return {
        loader: nextProps?.auth?.loader,
      };
    }
    if (nextProps?.errors !== nextState.errors) {
      return {
        errors: nextProps?.errors,
      };
    }
    return null;
  }

  onChange = (e) => {
    // this.setState({
    //   [e.target.name]: e.target.value,
    //   actionButton: true,
    // });
    let caps = e.target.value;
    caps = caps.charAt(0).toUpperCase() + caps.slice(1);
    let dataSet = caps;
    this.setState({
      [e.target.name]: dataSet,
      actionButton: true,
    });
  };

  onFocusOut = (e) => {
    const { errors } = this.state;
    if (e.target.value === "") {
      errors[e.target.name] = `${e.target.name} is required`;
    } else {
      errors[e.target.name] = "";
    }
    this.setState({
      errors: errors,
      actionButton: true,
    });
  };

  /**************************
   * @DESC - Current and Saving HANDLER
   ***************************/
  entryPointCheckSwitchValue = (e) => {
    this.setState({
      healthAndSanitizeEntryPointCheck:
        !this.state.healthAndSanitizeEntryPointCheck,
      actionButton: true,
    });
  };

  facilityCheckSwitchValue = (e) => {
    this.setState({
      healthAndSanitizeFacilityCheck:
        !this.state.healthAndSanitizeFacilityCheck,
      actionButton: true,
    });
  };

  servicesCheckSwitchValue = (e) => {
    this.setState({
      healthAndSanitizeServicesCheck:
        !this.state.healthAndSanitizeServicesCheck,
      actionButton: true,
    });
  };

  employeesCheckSwitchValue = (e) => {
    this.setState({
      healthAndSanitizeEmployeesCheck:
        !this.state.healthAndSanitizeEmployeesCheck,
      actionButton: true,
    });
  };

  practicesCheckSwitchValue = (e) => {
    this.setState({
      healthAndSanitizePracticesCheck:
        !this.state.healthAndSanitizePracticesCheck,
      actionButton: true,
    });
  };

  protocolCheckSwitchValue = (e) => {
    this.setState({
      healthAndSanitizeProtocolCheck:
        !this.state.healthAndSanitizeProtocolCheck,
      actionButton: true,
    });
  };

  onClickHomeButton = (e) => {
    // let formData = {
    //   id: this.props.onboarding._id,
    //   vendor_id: this.props.auth.user.VendorUser._id,
    //   healthAndSanitizeSwitchValue: true,
    // };
    // this.props.create_and_update_restaurant(formData);
    this.setState({
      healthAndSanitizeSwitchValue: true,
    });
  };

  /********************************
   * @DESC Entery Point Handler
   ********************************/
  onEnteryPointBackButton = (e) => {
    // let formData = {
    //   selectedPage: 1,
    //   id: this.props.onboarding._id,
    //   vendor_id: this.props.auth.user.VendorUser._id,
    //   healthAndSanitizeSwitchValue: false,
    // };
    // this.props.create_and_update_restaurant(formData);
    this.setState({
      actionButton: false,
      healthAndSanitizeSwitchValue: false,
    });
    // this.props.history.push("/pointofsale");
    // this.setState({
    //   healthAndSanitizeSwitchValue: false,
    //   actionButton: false,
    // });
  };
  whithOutEnteryPointNextButton = (e) => {
    this.setState({
      selectedPage: 2,
      healthAndSanitizeSwitchValue: true,
      actionButton: false,
    });
    this.props.history.push(
      this.props?.editDataAction
        ? "/admin_edit_healthAndsenitation"
        : "/addvendorhealthAndsenitation"
    );
  };
  onEnteryPointNextButton = (e) => {
    let onboarding = this.props?.editDataAction
      ? this.props?.editData
      : this.props?.onboardingData;
    let formData = {
      healthAndSanitizeEntryPointCheck:
        this.state.healthAndSanitizeEntryPointCheck,
      selected_health_and_sanitization_entrypoint:
        this.state.selected_health_and_sanitization_entrypoint,
      primary_health_and_sanitization_entrypoint:
        this.state.primary_health_and_sanitization_entrypoint,
      selectedPage: 2,
      vendor_id: onboarding?.vendor_id,
      id: onboarding?._id,
    };
    this.props.superadmin_create_and_update_restaurant(formData);
    this.setState({
      selectedPage: 2,
      healthAndSanitizeSwitchValue: true,
      actionButton: false,
    });
    this.props.history.push(
      this.props?.editDataAction
        ? "/admin_edit_healthAndsenitation"
        : "/addvendorhealthAndsenitation"
    );
  };

  /********************************
   * @DESC Inside Facility Handler
   ********************************/
  onInsideFacilityBackButton = (e) => {
    this.setState({
      selectedPage: 1,
      healthAndSanitizeSwitchValue: true,
      actionButton: false,
    });
    this.props.history.push(
      this.props?.editDataAction
        ? "/admin_edit_healthAndsenitation"
        : "/addvendorhealthAndsenitation"
    );
  };
  whithOutInsideFacilityNextButton = (e) => {
    this.setState({
      selectedPage: 3,
      healthAndSanitizeSwitchValue: true,
      actionButton: false,
    });
    this.props.history.push(
      this.props?.editDataAction
        ? "/admin_edit_healthAndsenitation"
        : "/addvendorhealthAndsenitation"
    );
  };
  onInsideFacilityNextButton = (e) => {
    let onboarding = this.props?.editDataAction
      ? this.props?.editData
      : this.props?.onboardingData;
    let formData = {
      healthAndSanitizeFacilityCheck: this.state.healthAndSanitizeFacilityCheck,
      selected_health_and_sanitization_facility:
        this.state.selected_health_and_sanitization_facility,
      primary_health_and_sanitization_facility:
        this.state.primary_health_and_sanitization_facility,
      selectedPage: 3,
      vendor_id: onboarding?.vendor_id,
      id: onboarding?._id,
    };
    this.props.superadmin_create_and_update_restaurant(formData);
    this.setState({
      selectedPage: 3,
      healthAndSanitizeSwitchValue: true,
      actionButton: false,
    });
    this.props.history.push(
      this.props?.editDataAction
        ? "/admin_edit_healthAndsenitation"
        : "/addvendorhealthAndsenitation"
    );
  };

  /********************************
   * @DESC Employee Handler
   ********************************/
  onEmployeesBackButton = (e) => {
    this.setState({
      selectedPage: 2,
      healthAndSanitizeSwitchValue: true,
      actionButton: false,
    });
    this.props.history.push(
      this.props?.editDataAction
        ? "/admin_edit_healthAndsenitation"
        : "/addvendorhealthAndsenitation"
    );
  };
  whithOutEmployeesNextButton = (e) => {
    this.setState({
      selectedPage: 4,
      healthAndSanitizeSwitchValue: true,
      actionButton: false,
    });
    this.props.history.push(
      this.props?.editDataAction
        ? "/admin_edit_healthAndsenitation"
        : "/addvendorhealthAndsenitation"
    );
  };
  onEmployeesNextButton = (e) => {
    let onboarding = this.props?.editDataAction
      ? this.props?.editData
      : this.props?.onboardingData;
    let formData = {
      healthAndSanitizeEmployeesCheck:
        this.state.healthAndSanitizeEmployeesCheck,
      selected_health_and_sanitization_employees:
        this.state.selected_health_and_sanitization_employees,
      primary_health_and_sanitization_employees:
        this.state.primary_health_and_sanitization_employees,
      selectedPage: 4,
      vendor_id: onboarding?.vendor_id,
      id: onboarding?._id,
    };
    this.props.superadmin_create_and_update_restaurant(formData);
    this.setState({
      selectedPage: 4,
      healthAndSanitizeSwitchValue: true,
      actionButton: false,
    });
    this.props.history.push(
      this.props?.editDataAction
        ? "/admin_edit_healthAndsenitation"
        : "/addvendorhealthAndsenitation"
    );
  };

  /********************************
   * @DESC Food Handling Handler
   ********************************/
  onFoodHandlingBackButton = (e) => {
    this.setState({
      selectedPage: 3,
      healthAndSanitizeSwitchValue: true,
      actionButton: false,
    });
    this.props.history.push(
      this.props?.editDataAction
        ? "/admin_edit_healthAndsenitation"
        : "/addvendorhealthAndsenitation"
    );
  };
  whithOutFoodHandlingNextButton = (e) => {
    this.setState({
      selectedPage: 5,
      healthAndSanitizeSwitchValue: true,
      actionButton: false,
    });
    this.props.history.push(
      this.props?.editDataAction
        ? "/admin_edit_healthAndsenitation"
        : "/addvendorhealthAndsenitation"
    );
  };
  onFoodHandlingNextButton = (e) => {
    let onboarding = this.props?.editDataAction
      ? this.props?.editData
      : this.props?.onboardingData;
    let formData = {
      healthAndSanitizeServicesCheck: this.state.healthAndSanitizeServicesCheck,
      selected_health_and_sanitization_food_handling:
        this.state.selected_health_and_sanitization_food_handling,
      primary_health_and_sanitization_food_handling:
        this.state.primary_health_and_sanitization_food_handling,
      selectedPage: 5,
      vendor_id: onboarding?.vendor_id,
      id: onboarding?._id,
    };
    this.props.superadmin_create_and_update_restaurant(formData);
    this.setState({
      selectedPage: 5,
      healthAndSanitizeSwitchValue: true,
      actionButton: false,
    });
    this.props.history.push(
      this.props?.editDataAction
        ? "/admin_edit_healthAndsenitation"
        : "/addvendorhealthAndsenitation"
    );
  };

  /********************************
   * @DESC Health Safety Handler
   ********************************/
  onHealthSafetyBackButton = (e) => {
    this.setState({
      selectedPage: 4,
      healthAndSanitizeSwitchValue: true,
      actionButton: false,
    });
    this.props.history.push(
      this.props?.editDataAction
        ? "/admin_edit_healthAndsenitation"
        : "/addvendorhealthAndsenitation"
    );
  };
  whithOutHealthSafetyNextButton = (e) => {
    this.setState({
      selectedPage: 6,
      healthAndSanitizeSwitchValue: true,
      actionButton: false,
    });
    this.props.history.push(
      this.props?.editDataAction
        ? "/admin_edit_healthAndsenitation"
        : "/addvendorhealthAndsenitation"
    );
  };
  onHealthSafetyNextButton = (e) => {
    let onboarding = this.props?.editDataAction
      ? this.props?.editData
      : this.props?.onboardingData;
    let formData = {
      healthAndSanitizePracticesCheck:
        this.state.healthAndSanitizePracticesCheck,
      selected_health_and_sanitization_health_safety:
        this.state.selected_health_and_sanitization_health_safety,
      primary_health_and_sanitization_health_safety:
        this.state.primary_health_and_sanitization_health_safety,
      selectedPage: 6,
      vendor_id: onboarding?.vendor_id,
      id: onboarding?._id,
    };
    this.props.superadmin_create_and_update_restaurant(formData);
    this.setState({
      selectedPage: 6,
      healthAndSanitizeSwitchValue: true,
      actionButton: false,
    });
    this.props.history.push(
      this.props?.editDataAction
        ? "/admin_edit_healthAndsenitation"
        : "/addvendorhealthAndsenitation"
    );
  };

  /****************************************
   * @DESC Discription Protocol Handler
   ***************************************/
  onDiscriptionProtocolBackButton = (e) => {
    this.setState({
      selectedPage: 5,
      healthAndSanitizeSwitchValue: true,
      actionButton: false,
    });
    this.props.history.push(
      this.props?.editDataAction
        ? "/admin_edit_healthAndsenitation"
        : "/addvendorhealthAndsenitation"
    );
  };
  whithOutDiscriptionProtocolNextButton = (e) => {
    this.setState({
      actionButton: false,
    });
    this.props.history.push(
      this.props?.editDataAction
        ? "/admin_edit_cuisinesetup"
        : "/addvendorcuisinesetup"
    );
  };

  /*********************************************
   * @DESC - onLocated Inside Array Selector
   *********************************************/
  onLocatedInsideArraySelector = (icon) => (e) => {
    e.preventDefault();
    let restaurantTypeArray = this.state.selected_health_and_sanitization;
    if (restaurantTypeArray.length === 0) {
      restaurantTypeArray.push(icon);
    } else {
      let isAlreadyPresent = restaurantTypeArray.includes(icon);
      if (isAlreadyPresent) {
        let indexOf = restaurantTypeArray.indexOf(icon);
        if (indexOf === 0 || indexOf) {
          restaurantTypeArray.splice(indexOf, 1);
        }
      } else {
        restaurantTypeArray.push(icon);
      }
    }
    this.setState({
      selected_health_and_sanitization: restaurantTypeArray,
      actionButton: true,
    });
  };

  /****************************************
   * @DESC - Others Health Seafty SELECTOR
   ****************************************/
  othersHealthAndSafetyHandler = (icon, index) => (e) => {
    let buttonArray = this.state.healthandsanitization_entrypoint;
    buttonArray.splice(index, 1);
    let Restaurant = this.state.selected_health_and_sanitization_entrypoint;
    let primaryIcon = this.state.primary_health_and_sanitization_entrypoint;
    if (Restaurant.length === 0 || primaryIcon === {}) {
      Restaurant.push(icon);
      this.setState({
        selected_health_and_sanitization_entrypoint: Restaurant,
        primary_health_and_sanitization_entrypoint: icon,
        actionButton: true,
      });
    } else {
      let isAlreadyPresent = Restaurant.includes(icon);
      if (isAlreadyPresent) {
        let indexOf = Restaurant.indexOf(icon);
        if (indexOf === 0 || indexOf) {
          Restaurant.splice(indexOf, 1);
        }
      } else {
        Restaurant.push(icon);
      }
    }
    this.setState({
      selected_health_and_sanitization_entrypoint: Restaurant,
      actionButton: true,
    });
  };

  othersHealthAndSafetyHandlerTwo = (icon, index) => (e) => {
    let buttonArray = this.state.healthandsanitization_facility;
    buttonArray.splice(index, 1);
    let Restaurant = this.state.selected_health_and_sanitization_facility;
    let primaryIcon = this.state.primary_health_and_sanitization_facility;
    if (Restaurant.length === 0 || primaryIcon === {}) {
      Restaurant.push(icon);
      this.setState({
        selected_health_and_sanitization_facility: Restaurant,
        primary_health_and_sanitization_facility: icon,
        actionButton: true,
      });
    } else {
      let isAlreadyPresent = Restaurant.includes(icon);
      if (isAlreadyPresent) {
        let indexOf = Restaurant.indexOf(icon);
        if (indexOf === 0 || indexOf) {
          Restaurant.splice(indexOf, 1);
        }
      } else {
        Restaurant.push(icon);
      }
    }
    this.setState({
      selected_health_and_sanitization_facility: Restaurant,
      actionButton: true,
    });
  };

  othersHealthAndSafetyHandlerThree = (icon, index) => (e) => {
    let buttonArray = this.state.healthandsanitization_employees;
    buttonArray.splice(index, 1);
    let Restaurant = this.state.selected_health_and_sanitization_employees;
    let primaryIcon = this.state.primary_health_and_sanitization_employees;
    if (Restaurant.length === 0 || primaryIcon === {}) {
      Restaurant.push(icon);
      this.setState({
        selected_health_and_sanitization_employees: Restaurant,
        primary_health_and_sanitization_employees: icon,
        actionButton: true,
      });
    } else {
      let isAlreadyPresent = Restaurant.includes(icon);
      if (isAlreadyPresent) {
        let indexOf = Restaurant.indexOf(icon);
        if (indexOf === 0 || indexOf) {
          Restaurant.splice(indexOf, 1);
        }
      } else {
        Restaurant.push(icon);
      }
    }
    this.setState({
      selected_health_and_sanitization_employees: Restaurant,
      actionButton: true,
    });
  };

  othersHealthAndSafetyHandlerFour = (icon, index) => (e) => {
    let buttonArray = this.state.healthandsanitization_food_handling;
    buttonArray.splice(index, 1);
    let Restaurant = this.state.selected_health_and_sanitization_food_handling;
    let primaryIcon = this.state.primary_health_and_sanitization_food_handling;
    if (Restaurant.length === 0 || primaryIcon === {}) {
      Restaurant.push(icon);
      this.setState({
        selected_health_and_sanitization_food_handling: Restaurant,
        primary_health_and_sanitization_food_handling: icon,
        actionButton: true,
      });
    } else {
      let isAlreadyPresent = Restaurant.includes(icon);
      if (isAlreadyPresent) {
        let indexOf = Restaurant.indexOf(icon);
        if (indexOf === 0 || indexOf) {
          Restaurant.splice(indexOf, 1);
        }
      } else {
        Restaurant.push(icon);
      }
    }
    this.setState({
      selected_health_and_sanitization_food_handling: Restaurant,
      actionButton: true,
    });
  };

  othersHealthAndSafetyHandlerFive = (icon, index) => (e) => {
    let buttonArray = this.state.healthandsanitization_health_safety;
    buttonArray.splice(index, 1);
    let Restaurant = this.state.selected_health_and_sanitization_health_safety;
    let primaryIcon = this.state.primary_health_and_sanitization_health_safety;
    if (Restaurant.length === 0 || primaryIcon === {}) {
      Restaurant.push(icon);
      this.setState({
        selected_health_and_sanitization_health_safety: Restaurant,
        primary_health_and_sanitization_health_safety: icon,
        actionButton: true,
      });
    } else {
      let isAlreadyPresent = Restaurant.includes(icon);
      if (isAlreadyPresent) {
        let indexOf = Restaurant.indexOf(icon);
        if (indexOf === 0 || indexOf) {
          Restaurant.splice(indexOf, 1);
        }
      } else {
        Restaurant.push(icon);
      }
    }
    this.setState({
      selected_health_and_sanitization_health_safety: Restaurant,
      actionButton: true,
    });
  };

  othersHealthAndSafetyPrimarySelector = (icon) => (e) => {
    this.setState({
      primary_health_and_sanitization_entrypoint: icon,
      actionButton: true,
    });
  };
  othersHealthAndSafetyPrimarySelectorTwo = (icon) => (e) => {
    this.setState({
      primary_health_and_sanitization_facility: icon,
      actionButton: true,
    });
  };
  othersHealthAndSafetyPrimarySelectorThree = (icon) => (e) => {
    this.setState({
      primary_health_and_sanitization_employees: icon,
      actionButton: true,
    });
  };
  othersHealthAndSafetyPrimarySelectorFour = (icon) => (e) => {
    this.setState({
      primary_health_and_sanitization_food_handling: icon,
      actionButton: true,
    });
  };
  othersHealthAndSafetyPrimarySelectorFive = (icon) => (e) => {
    this.setState({
      primary_health_and_sanitization_health_safety: icon,
      actionButton: true,
    });
  };

  /****************************************
   * @DESC - Remove Primary button handler
   ****************************************/
  othersHealthAndSafetyRemoveButton = (icon) => (e) => {
    let {
      healthandsanitization_entrypoint,
      selected_health_and_sanitization_entrypoint,
      primary_health_and_sanitization_entrypoint,
    } = this.state;

    let iconIndexAtAllIcons = healthandsanitization_entrypoint.findIndex(
      (icons) => icons._id === icon._id
    );
    let iconIndexAtSelectedIcons =
      selected_health_and_sanitization_entrypoint.findIndex(
        (icons) => icons._id === icon._id
      );
    let iconAtPrimaryIcon =
      !isEmpty(primary_health_and_sanitization_entrypoint) &&
      primary_health_and_sanitization_entrypoint._id === icon._id
        ? true
        : false;
    if (selected_health_and_sanitization_entrypoint.length === 0) {
      selected_health_and_sanitization_entrypoint.push(icon);
      healthandsanitization_entrypoint.splice(iconIndexAtAllIcons, 1);
      primary_health_and_sanitization_entrypoint = icon;
    } else if (iconAtPrimaryIcon) {
      selected_health_and_sanitization_entrypoint.splice(
        iconIndexAtSelectedIcons,
        1
      );
      healthandsanitization_entrypoint.push(icon);
      if (selected_health_and_sanitization_entrypoint.length === 1) {
        primary_health_and_sanitization_entrypoint =
          selected_health_and_sanitization_entrypoint[0];
      } else {
        primary_health_and_sanitization_entrypoint = {};
      }
    } else if (iconIndexAtSelectedIcons === 0 || iconIndexAtSelectedIcons) {
      selected_health_and_sanitization_entrypoint.splice(
        iconIndexAtSelectedIcons,
        1
      );
      healthandsanitization_entrypoint.push(icon);
      if (selected_health_and_sanitization_entrypoint.length === 1) {
        primary_health_and_sanitization_entrypoint =
          selected_health_and_sanitization_entrypoint[0];
      }
    } else {
      selected_health_and_sanitization_entrypoint.push(icon);
      healthandsanitization_entrypoint.splice(iconIndexAtAllIcons, 1);
    }

    this.setState({
      selected_health_and_sanitization_entrypoint:
        selected_health_and_sanitization_entrypoint,
      healthandsanitization_entrypoint: healthandsanitization_entrypoint,
      primary_health_and_sanitization_entrypoint:
        primary_health_and_sanitization_entrypoint,
      actionButton: true,
    });
  };

  othersHealthAndSafetyRemoveButtonTwo = (icon) => (e) => {
    let {
      healthandsanitization_facility,
      selected_health_and_sanitization_facility,
      primary_health_and_sanitization_facility,
    } = this.state;

    let iconIndexAtAllIcons = healthandsanitization_facility.findIndex(
      (icons) => icons._id === icon._id
    );
    let iconIndexAtSelectedIcons =
      selected_health_and_sanitization_facility.findIndex(
        (icons) => icons._id === icon._id
      );
    let iconAtPrimaryIcon =
      !isEmpty(primary_health_and_sanitization_facility) &&
      primary_health_and_sanitization_facility._id === icon._id
        ? true
        : false;
    if (selected_health_and_sanitization_facility.length === 0) {
      selected_health_and_sanitization_facility.push(icon);
      healthandsanitization_facility.splice(iconIndexAtAllIcons, 1);
      primary_health_and_sanitization_facility = icon;
    } else if (iconAtPrimaryIcon) {
      selected_health_and_sanitization_facility.splice(
        iconIndexAtSelectedIcons,
        1
      );
      healthandsanitization_facility.push(icon);
      if (selected_health_and_sanitization_facility.length === 1) {
        primary_health_and_sanitization_facility =
          selected_health_and_sanitization_facility[0];
      } else {
        primary_health_and_sanitization_facility = {};
      }
    } else if (iconIndexAtSelectedIcons === 0 || iconIndexAtSelectedIcons) {
      selected_health_and_sanitization_facility.splice(
        iconIndexAtSelectedIcons,
        1
      );
      healthandsanitization_facility.push(icon);
      if (selected_health_and_sanitization_facility.length === 1) {
        primary_health_and_sanitization_facility =
          selected_health_and_sanitization_facility[0];
      }
    } else {
      selected_health_and_sanitization_facility.push(icon);
      healthandsanitization_facility.splice(iconIndexAtAllIcons, 1);
    }

    this.setState({
      selected_health_and_sanitization_facility:
        selected_health_and_sanitization_facility,
      healthandsanitization_facility: healthandsanitization_facility,
      primary_health_and_sanitization_facility:
        primary_health_and_sanitization_facility,
      actionButton: true,
    });
  };

  othersHealthAndSafetyRemoveButtonThree = (icon) => (e) => {
    let {
      healthandsanitization_employees,
      selected_health_and_sanitization_employees,
      primary_health_and_sanitization_employees,
    } = this.state;

    let iconIndexAtAllIcons = healthandsanitization_employees.findIndex(
      (icons) => icons._id === icon._id
    );
    let iconIndexAtSelectedIcons =
      selected_health_and_sanitization_employees.findIndex(
        (icons) => icons._id === icon._id
      );
    let iconAtPrimaryIcon =
      !isEmpty(primary_health_and_sanitization_employees) &&
      primary_health_and_sanitization_employees._id === icon._id
        ? true
        : false;
    if (selected_health_and_sanitization_employees.length === 0) {
      selected_health_and_sanitization_employees.push(icon);
      healthandsanitization_employees.splice(iconIndexAtAllIcons, 1);
      primary_health_and_sanitization_employees = icon;
    } else if (iconAtPrimaryIcon) {
      selected_health_and_sanitization_employees.splice(
        iconIndexAtSelectedIcons,
        1
      );
      healthandsanitization_employees.push(icon);
      if (selected_health_and_sanitization_employees.length === 1) {
        primary_health_and_sanitization_employees =
          selected_health_and_sanitization_employees[0];
      } else {
        primary_health_and_sanitization_employees = {};
      }
    } else if (iconIndexAtSelectedIcons === 0 || iconIndexAtSelectedIcons) {
      selected_health_and_sanitization_employees.splice(
        iconIndexAtSelectedIcons,
        1
      );
      healthandsanitization_employees.push(icon);
      if (selected_health_and_sanitization_employees.length === 1) {
        primary_health_and_sanitization_employees =
          selected_health_and_sanitization_employees[0];
      }
    } else {
      selected_health_and_sanitization_employees.push(icon);
      healthandsanitization_employees.splice(iconIndexAtAllIcons, 1);
    }

    this.setState({
      selected_health_and_sanitization_employees:
        selected_health_and_sanitization_employees,
      healthandsanitization_employees: healthandsanitization_employees,
      primary_health_and_sanitization_employees:
        primary_health_and_sanitization_employees,
      actionButton: true,
    });
  };

  othersHealthAndSafetyRemoveButtonFour = (icon) => (e) => {
    let {
      healthandsanitization_food_handling,
      selected_health_and_sanitization_food_handling,
      primary_health_and_sanitization_food_handling,
    } = this.state;

    let iconIndexAtAllIcons = healthandsanitization_food_handling.findIndex(
      (icons) => icons._id === icon._id
    );
    let iconIndexAtSelectedIcons =
      selected_health_and_sanitization_food_handling.findIndex(
        (icons) => icons._id === icon._id
      );
    let iconAtPrimaryIcon =
      !isEmpty(primary_health_and_sanitization_food_handling) &&
      primary_health_and_sanitization_food_handling._id === icon._id
        ? true
        : false;
    if (selected_health_and_sanitization_food_handling.length === 0) {
      selected_health_and_sanitization_food_handling.push(icon);
      healthandsanitization_food_handling.splice(iconIndexAtAllIcons, 1);
      primary_health_and_sanitization_food_handling = icon;
    } else if (iconAtPrimaryIcon) {
      selected_health_and_sanitization_food_handling.splice(
        iconIndexAtSelectedIcons,
        1
      );
      healthandsanitization_food_handling.push(icon);
      if (selected_health_and_sanitization_food_handling.length === 1) {
        primary_health_and_sanitization_food_handling =
          selected_health_and_sanitization_food_handling[0];
      } else {
        primary_health_and_sanitization_food_handling = {};
      }
    } else if (iconIndexAtSelectedIcons === 0 || iconIndexAtSelectedIcons) {
      selected_health_and_sanitization_food_handling.splice(
        iconIndexAtSelectedIcons,
        1
      );
      healthandsanitization_food_handling.push(icon);
      if (selected_health_and_sanitization_food_handling.length === 1) {
        primary_health_and_sanitization_food_handling =
          selected_health_and_sanitization_food_handling[0];
      }
    } else {
      selected_health_and_sanitization_food_handling.push(icon);
      healthandsanitization_food_handling.splice(iconIndexAtAllIcons, 1);
    }

    this.setState({
      selected_health_and_sanitization_food_handling:
        selected_health_and_sanitization_food_handling,
      healthandsanitization_food_handling: healthandsanitization_food_handling,
      primary_health_and_sanitization_food_handling:
        primary_health_and_sanitization_food_handling,
      actionButton: true,
    });
  };

  othersHealthAndSafetyRemoveButtonFive = (icon) => (e) => {
    let {
      healthandsanitization_health_safety,
      selected_health_and_sanitization_health_safety,
      primary_health_and_sanitization_health_safety,
    } = this.state;

    let iconIndexAtAllIcons = healthandsanitization_health_safety.findIndex(
      (icons) => icons._id === icon._id
    );
    let iconIndexAtSelectedIcons =
      selected_health_and_sanitization_health_safety.findIndex(
        (icons) => icons._id === icon._id
      );
    let iconAtPrimaryIcon =
      !isEmpty(primary_health_and_sanitization_health_safety) &&
      primary_health_and_sanitization_health_safety._id === icon._id
        ? true
        : false;
    if (selected_health_and_sanitization_health_safety.length === 0) {
      selected_health_and_sanitization_health_safety.push(icon);
      healthandsanitization_health_safety.splice(iconIndexAtAllIcons, 1);
      primary_health_and_sanitization_health_safety = icon;
    } else if (iconAtPrimaryIcon) {
      selected_health_and_sanitization_health_safety.splice(
        iconIndexAtSelectedIcons,
        1
      );
      healthandsanitization_health_safety.push(icon);
      if (selected_health_and_sanitization_health_safety.length === 1) {
        primary_health_and_sanitization_health_safety =
          selected_health_and_sanitization_health_safety[0];
      } else {
        primary_health_and_sanitization_health_safety = {};
      }
    } else if (iconIndexAtSelectedIcons === 0 || iconIndexAtSelectedIcons) {
      selected_health_and_sanitization_health_safety.splice(
        iconIndexAtSelectedIcons,
        1
      );
      healthandsanitization_health_safety.push(icon);
      if (selected_health_and_sanitization_health_safety.length === 1) {
        primary_health_and_sanitization_health_safety =
          selected_health_and_sanitization_health_safety[0];
      }
    } else {
      selected_health_and_sanitization_health_safety.push(icon);
      healthandsanitization_health_safety.splice(iconIndexAtAllIcons, 1);
    }

    this.setState({
      selected_health_and_sanitization_health_safety:
        selected_health_and_sanitization_health_safety,
      healthandsanitization_health_safety: healthandsanitization_health_safety,
      primary_health_and_sanitization_health_safety:
        primary_health_and_sanitization_health_safety,
      actionButton: true,
    });
  };

  // onChange = (e) => {
  //   // this.setState({
  //   //   [e.target.name]: e.target.value,
  //   //   actionButton: true,
  //   // });
  //   let caps = e.target.value;
  //   caps = caps.charAt(0).toUpperCase() + caps.slice(1);
  //   let dataSet = caps;
  //   this.setState({
  //     [e.target.name]: dataSet,
  //     actionButton: true,
  //   });
  // };

  // onFocusOut = (e) => {
  //   const { errors } = this.state;
  //   if (e.target.value === "") {
  //     errors[e.target.name] = `${e.target.name} is required`;
  //   } else {
  //     errors[e.target.name] = "";
  //   }
  //   this.setState({
  //     errors: errors,
  //     actionButton: true,
  //   });
  // };

  // /**************************
  //  * @DESC - Current and Saving HANDLER
  //  ***************************/
  // entryPointCheckSwitchValue = (e) => {
  //   this.setState({
  //     healthAndSanitizeEntryPointCheck:
  //       !this.state.healthAndSanitizeEntryPointCheck,
  //     actionButton: true,
  //   });
  // };

  // facilityCheckSwitchValue = (e) => {
  //   this.setState({
  //     healthAndSanitizeFacilityCheck:
  //       !this.state.healthAndSanitizeFacilityCheck,
  //     actionButton: true,
  //   });
  // };

  // servicesCheckSwitchValue = (e) => {
  //   console.log("hi1");
  //   this.setState({
  //     healthAndSanitizeServicesCheck:
  //       !this.state.healthAndSanitizeServicesCheck,
  //     actionButton: true,
  //   });
  // };

  // employeesCheckSwitchValue = (e) => {
  //   console.log("hi2");
  //   this.setState({
  //     healthAndSanitizeEmployeesCheck:
  //       !this.state.healthAndSanitizeEmployeesCheck,
  //     actionButton: true,
  //   });
  // };

  // practicesCheckSwitchValue = (e) => {
  //   this.setState({
  //     healthAndSanitizePracticesCheck:
  //       !this.state.healthAndSanitizePracticesCheck,
  //     actionButton: true,
  //   });
  // };

  // protocolCheckSwitchValue = (e) => {
  //   this.setState({
  //     healthAndSanitizeProtocolCheck:
  //       !this.state.healthAndSanitizeProtocolCheck,
  //     actionButton: true,
  //   });
  // };

  // onClickHomeButton = (e) => {
  //   // let formData = {
  //   //   id: this.props.onboarding._id,
  //   //   vendor_id: this.state.vendor_id,
  //   //   healthAndSanitizeSwitchValue: true,
  //   // };
  //   // this.props.create_and_update_restaurant(formData);
  //   this.setState({
  //     healthAndSanitizeSwitchValue: true,
  //   });
  // };

  // /********************************
  //  * @DESC Entery Point Handler
  //  ********************************/
  // onEnteryPointBackButton = (e) => {
  //   // let formData = {
  //   //   selectedPage: 1,
  //   //   id: this.props.onboarding._id,
  //   //   vendor_id: this.state.vendor_id,
  //   //   healthAndSanitizeSwitchValue: false,
  //   // };
  //   // this.props.create_and_update_restaurant(formData);
  //   this.setState({
  //     actionButton: false,
  //     healthAndSanitizeSwitchValue: false,
  //   });
  //   // this.props.history.push("/pointofsale");
  //   // this.setState({
  //   //   healthAndSanitizeSwitchValue: false,
  //   //   actionButton: false,
  //   // });
  // };
  // whithOutEnteryPointNextButton = (e) => {
  //   this.setState({
  //     selectedPage: 2,
  //     healthAndSanitizeSwitchValue: true,
  //     actionButton: false,
  //   });
  // };
  // onEnteryPointNextButton = (e) => {
  //   let formData = {
  //     healthAndSanitizeEntryPointCheck:
  //       this.state.healthAndSanitizeEntryPointCheck,
  //     selected_health_and_sanitization_entrypoint:
  //       this.state.selected_health_and_sanitization_entrypoint,
  //     primary_health_and_sanitization_entrypoint:
  //       this.state.primary_health_and_sanitization_entrypoint,
  //     selectedPage: 1,
  //     id: this.props.onboarding._id,
  //     vendor_id: this.state.vendor_id,
  //   };
  //   this.props.superadmin_create_and_update_restaurant(formData);
  //   this.setState({
  //     selectedPage: 2,
  //     healthAndSanitizeSwitchValue: true,
  //     actionButton: false,
  //   });
  // };

  // /********************************
  //  * @DESC Inside Facility Handler
  //  ********************************/
  // onInsideFacilityBackButton = (e) => {
  //   this.setState({
  //     selectedPage: 1,
  //     healthAndSanitizeSwitchValue: true,
  //     actionButton: false,
  //   });
  // };
  // whithOutInsideFacilityNextButton = (e) => {
  //   this.setState({
  //     selectedPage: 3,
  //     healthAndSanitizeSwitchValue: true,
  //     actionButton: false,
  //   });
  // };
  // onInsideFacilityNextButton = (e) => {
  //   let formData = {
  //     healthAndSanitizeFacilityCheck: this.state.healthAndSanitizeFacilityCheck,
  //     selected_health_and_sanitization_facility:
  //       this.state.selected_health_and_sanitization_facility,
  //     primary_health_and_sanitization_facility:
  //       this.state.primary_health_and_sanitization_facility,
  //     selectedPage: 2,
  //     id: this.props.onboarding._id,
  //     vendor_id: this.state.vendor_id,
  //   };
  //   this.props.superadmin_create_and_update_restaurant(formData);
  //   this.setState({
  //     selectedPage: 3,
  //     healthAndSanitizeSwitchValue: true,
  //     actionButton: false,
  //   });
  // };

  // /********************************
  //  * @DESC Employee Handler
  //  ********************************/
  // onEmployeesBackButton = (e) => {
  //   this.setState({
  //     selectedPage: 2,
  //     healthAndSanitizeSwitchValue: true,
  //     actionButton: false,
  //   });
  // };
  // whithOutEmployeesNextButton = (e) => {
  //   this.setState({
  //     selectedPage: 4,
  //     healthAndSanitizeSwitchValue: true,
  //     actionButton: false,
  //   });
  // };
  // onEmployeesNextButton = (e) => {
  //   let formData = {
  //     healthAndSanitizeEmployeesCheck:
  //       this.state.healthAndSanitizeEmployeesCheck,
  //     selected_health_and_sanitization_employees:
  //       this.state.selected_health_and_sanitization_employees,
  //     primary_health_and_sanitization_employees:
  //       this.state.primary_health_and_sanitization_employees,
  //     selectedPage: 3,
  //     id: this.props.onboarding._id,
  //     vendor_id: this.state.vendor_id,
  //   };
  //   this.props.superadmin_create_and_update_restaurant(formData);
  //   this.setState({
  //     selectedPage: 4,
  //     healthAndSanitizeSwitchValue: true,
  //     actionButton: false,
  //   });
  // };

  // /********************************
  //  * @DESC Food Handling Handler
  //  ********************************/
  // onFoodHandlingBackButton = (e) => {
  //   this.setState({
  //     selectedPage: 3,
  //     healthAndSanitizeSwitchValue: true,
  //     actionButton: false,
  //   });
  // };
  // whithOutFoodHandlingNextButton = (e) => {
  //   this.setState({
  //     selectedPage: 5,
  //     healthAndSanitizeSwitchValue: true,
  //     actionButton: false,
  //   });
  // };
  // onFoodHandlingNextButton = (e) => {
  //   let formData = {
  //     healthAndSanitizeServicesCheck: this.state.healthAndSanitizeServicesCheck,
  //     selected_health_and_sanitization_food_handling:
  //       this.state.selected_health_and_sanitization_food_handling,
  //     primary_health_and_sanitization_food_handling:
  //       this.state.primary_health_and_sanitization_food_handling,
  //     selectedPage: 4,
  //     id: this.props.onboarding._id,
  //     vendor_id: this.state.vendor_id,
  //   };
  //   this.props.superadmin_create_and_update_restaurant(formData);
  //   this.setState({
  //     selectedPage: 5,
  //     healthAndSanitizeSwitchValue: true,
  //     actionButton: false,
  //   });
  // };

  // /********************************
  //  * @DESC Health Safety Handler
  //  ********************************/
  // onHealthSafetyBackButton = (e) => {
  //   this.setState({
  //     selectedPage: 4,
  //     healthAndSanitizeSwitchValue: true,
  //     actionButton: false,
  //   });
  // };
  // whithOutHealthSafetyNextButton = (e) => {
  //   this.setState({
  //     selectedPage: 6,
  //     healthAndSanitizeSwitchValue: true,
  //     actionButton: false,
  //   });
  // };
  // onHealthSafetyNextButton = (e) => {
  //   let formData = {
  //     healthAndSanitizePracticesCheck:
  //       this.state.healthAndSanitizePracticesCheck,
  //     selected_health_and_sanitization_health_safety:
  //       this.state.selected_health_and_sanitization_health_safety,
  //     primary_health_and_sanitization_health_safety:
  //       this.state.primary_health_and_sanitization_health_safety,
  //     selectedPage: 5,
  //     id: this.props.onboarding._id,
  //     vendor_id: this.state.vendor_id,
  //   };
  //   this.props.superadmin_create_and_update_restaurant(formData);
  //   this.setState({
  //     selectedPage: 6,
  //     healthAndSanitizeSwitchValue: true,
  //     actionButton: false,
  //   });
  // };

  // /****************************************
  //  * @DESC Discription Protocol Handler
  //  ***************************************/
  // onDiscriptionProtocolBackButton = (e) => {
  //   this.setState({
  //     selectedPage: 5,
  //     healthAndSanitizeSwitchValue: true,
  //     actionButton: false,
  //   });
  // };
  // whithOutDiscriptionProtocolNextButton = (e) => {
  //   this.setState({
  //     actionButton: false,
  //   });
  //   this.props.history.push("/cuisinesetup");
  // };

  // /*********************************************
  //  * @DESC - onLocated Inside Array Selector
  //  *********************************************/
  // onLocatedInsideArraySelector = (icon) => (e) => {
  //   e.preventDefault();
  //   let restaurantTypeArray = this.state.selected_health_and_sanitization;
  //   if (restaurantTypeArray.length === 0) {
  //     restaurantTypeArray.push(icon);
  //   } else {
  //     let isAlreadyPresent = restaurantTypeArray.includes(icon);
  //     if (isAlreadyPresent) {
  //       let indexOf = restaurantTypeArray.indexOf(icon);
  //       if (indexOf === 0 || indexOf) {
  //         restaurantTypeArray.splice(indexOf, 1);
  //       }
  //     } else {
  //       restaurantTypeArray.push(icon);
  //     }
  //   }
  //   this.setState({
  //     selected_health_and_sanitization: restaurantTypeArray,
  //     actionButton: true,
  //   });
  // };

  // /****************************************
  //  * @DESC - Others Health Seafty SELECTOR
  //  ****************************************/
  // othersHealthAndSafetyHandler = (icon, index) => (e) => {
  //   let buttonArray = this.state.healthandsanitization_entrypoint;
  //   buttonArray.splice(index, 1);
  //   let Restaurant = this.state.selected_health_and_sanitization_entrypoint;
  //   let primaryIcon = this.state.primary_health_and_sanitization_entrypoint;
  //   if (Restaurant.length === 0 || primaryIcon === {}) {
  //     Restaurant.push(icon);
  //     this.setState({
  //       selected_health_and_sanitization_entrypoint: Restaurant,
  //       primary_health_and_sanitization_entrypoint: icon,
  //       actionButton: true,
  //     });
  //   } else {
  //     let isAlreadyPresent = Restaurant.includes(icon);
  //     if (isAlreadyPresent) {
  //       let indexOf = Restaurant.indexOf(icon);
  //       if (indexOf === 0 || indexOf) {
  //         Restaurant.splice(indexOf, 1);
  //       }
  //     } else {
  //       Restaurant.push(icon);
  //     }
  //   }
  //   this.setState({
  //     selected_health_and_sanitization_entrypoint: Restaurant,
  //     actionButton: true,
  //   });
  // };

  // othersHealthAndSafetyHandlerTwo = (icon, index) => (e) => {
  //   let buttonArray = this.state.healthandsanitization_facility;
  //   buttonArray.splice(index, 1);
  //   let Restaurant = this.state.selected_health_and_sanitization_facility;
  //   let primaryIcon = this.state.primary_health_and_sanitization_facility;
  //   if (Restaurant.length === 0 || primaryIcon === {}) {
  //     Restaurant.push(icon);
  //     this.setState({
  //       selected_health_and_sanitization_facility: Restaurant,
  //       primary_health_and_sanitization_facility: icon,
  //       actionButton: true,
  //     });
  //   } else {
  //     let isAlreadyPresent = Restaurant.includes(icon);
  //     if (isAlreadyPresent) {
  //       let indexOf = Restaurant.indexOf(icon);
  //       if (indexOf === 0 || indexOf) {
  //         Restaurant.splice(indexOf, 1);
  //       }
  //     } else {
  //       Restaurant.push(icon);
  //     }
  //   }
  //   this.setState({
  //     selected_health_and_sanitization_facility: Restaurant,
  //     actionButton: true,
  //   });
  // };

  // othersHealthAndSafetyHandlerThree = (icon, index) => (e) => {
  //   let buttonArray = this.state.healthandsanitization_employees;
  //   buttonArray.splice(index, 1);
  //   let Restaurant = this.state.selected_health_and_sanitization_employees;
  //   let primaryIcon = this.state.primary_health_and_sanitization_employees;
  //   if (Restaurant.length === 0 || primaryIcon === {}) {
  //     Restaurant.push(icon);
  //     this.setState({
  //       selected_health_and_sanitization_employees: Restaurant,
  //       primary_health_and_sanitization_employees: icon,
  //       actionButton: true,
  //     });
  //   } else {
  //     let isAlreadyPresent = Restaurant.includes(icon);
  //     if (isAlreadyPresent) {
  //       let indexOf = Restaurant.indexOf(icon);
  //       if (indexOf === 0 || indexOf) {
  //         Restaurant.splice(indexOf, 1);
  //       }
  //     } else {
  //       Restaurant.push(icon);
  //     }
  //   }
  //   this.setState({
  //     selected_health_and_sanitization_employees: Restaurant,
  //     actionButton: true,
  //   });
  // };

  // othersHealthAndSafetyHandlerFour = (icon, index) => (e) => {
  //   let buttonArray = this.state.healthandsanitization_food_handling;
  //   buttonArray.splice(index, 1);
  //   let Restaurant = this.state.selected_health_and_sanitization_food_handling;
  //   let primaryIcon = this.state.primary_health_and_sanitization_food_handling;
  //   if (Restaurant.length === 0 || primaryIcon === {}) {
  //     Restaurant.push(icon);
  //     this.setState({
  //       selected_health_and_sanitization_food_handling: Restaurant,
  //       primary_health_and_sanitization_food_handling: icon,
  //       actionButton: true,
  //     });
  //   } else {
  //     let isAlreadyPresent = Restaurant.includes(icon);
  //     if (isAlreadyPresent) {
  //       let indexOf = Restaurant.indexOf(icon);
  //       if (indexOf === 0 || indexOf) {
  //         Restaurant.splice(indexOf, 1);
  //       }
  //     } else {
  //       Restaurant.push(icon);
  //     }
  //   }
  //   this.setState({
  //     selected_health_and_sanitization_food_handling: Restaurant,
  //     actionButton: true,
  //   });
  // };

  // othersHealthAndSafetyHandlerFive = (icon, index) => (e) => {
  //   let buttonArray = this.state.healthandsanitization_health_safety;
  //   buttonArray.splice(index, 1);
  //   let Restaurant = this.state.selected_health_and_sanitization_health_safety;
  //   let primaryIcon = this.state.primary_health_and_sanitization_health_safety;
  //   if (Restaurant.length === 0 || primaryIcon === {}) {
  //     Restaurant.push(icon);
  //     this.setState({
  //       selected_health_and_sanitization_health_safety: Restaurant,
  //       primary_health_and_sanitization_health_safety: icon,
  //       actionButton: true,
  //     });
  //   } else {
  //     let isAlreadyPresent = Restaurant.includes(icon);
  //     if (isAlreadyPresent) {
  //       let indexOf = Restaurant.indexOf(icon);
  //       if (indexOf === 0 || indexOf) {
  //         Restaurant.splice(indexOf, 1);
  //       }
  //     } else {
  //       Restaurant.push(icon);
  //     }
  //   }
  //   this.setState({
  //     selected_health_and_sanitization_health_safety: Restaurant,
  //     actionButton: true,
  //   });
  // };

  // othersHealthAndSafetyPrimarySelector = (icon) => (e) => {
  //   this.setState({
  //     primary_health_and_sanitization_entrypoint: icon,
  //     actionButton: true,
  //   });
  // };
  // othersHealthAndSafetyPrimarySelectorTwo = (icon) => (e) => {
  //   this.setState({
  //     primary_health_and_sanitization_facility: icon,
  //     actionButton: true,
  //   });
  // };
  // othersHealthAndSafetyPrimarySelectorThree = (icon) => (e) => {
  //   this.setState({
  //     primary_health_and_sanitization_employees: icon,
  //     actionButton: true,
  //   });
  // };
  // othersHealthAndSafetyPrimarySelectorFour = (icon) => (e) => {
  //   this.setState({
  //     primary_health_and_sanitization_food_handling: icon,
  //     actionButton: true,
  //   });
  // };
  // othersHealthAndSafetyPrimarySelectorFive = (icon) => (e) => {
  //   this.setState({
  //     primary_health_and_sanitization_health_safety: icon,
  //     actionButton: true,
  //   });
  // };

  // /****************************************
  //  * @DESC - Remove Primary button handler
  //  ****************************************/
  // othersHealthAndSafetyRemoveButton = (icon) => (e) => {
  //   let {
  //     healthandsanitization_entrypoint,
  //     selected_health_and_sanitization_entrypoint,
  //     primary_health_and_sanitization_entrypoint,
  //   } = this.state;

  //   let iconIndexAtAllIcons = healthandsanitization_entrypoint.findIndex(
  //     (icons) => icons._id === icon._id
  //   );
  //   let iconIndexAtSelectedIcons =
  //     selected_health_and_sanitization_entrypoint.findIndex(
  //       (icons) => icons._id === icon._id
  //     );
  //   let iconAtPrimaryIcon =
  //     !isEmpty(primary_health_and_sanitization_entrypoint) &&
  //     primary_health_and_sanitization_entrypoint._id === icon._id
  //       ? true
  //       : false;
  //   if (selected_health_and_sanitization_entrypoint.length === 0) {
  //     selected_health_and_sanitization_entrypoint.push(icon);
  //     healthandsanitization_entrypoint.splice(iconIndexAtAllIcons, 1);
  //     primary_health_and_sanitization_entrypoint = icon;
  //   } else if (iconAtPrimaryIcon) {
  //     selected_health_and_sanitization_entrypoint.splice(
  //       iconIndexAtSelectedIcons,
  //       1
  //     );
  //     healthandsanitization_entrypoint.push(icon);
  //     if (selected_health_and_sanitization_entrypoint.length === 1) {
  //       primary_health_and_sanitization_entrypoint =
  //         selected_health_and_sanitization_entrypoint[0];
  //     } else {
  //       primary_health_and_sanitization_entrypoint = {};
  //     }
  //   } else if (iconIndexAtSelectedIcons === 0 || iconIndexAtSelectedIcons) {
  //     selected_health_and_sanitization_entrypoint.splice(
  //       iconIndexAtSelectedIcons,
  //       1
  //     );
  //     healthandsanitization_entrypoint.push(icon);
  //     if (selected_health_and_sanitization_entrypoint.length === 1) {
  //       primary_health_and_sanitization_entrypoint =
  //         selected_health_and_sanitization_entrypoint[0];
  //     }
  //   } else {
  //     selected_health_and_sanitization_entrypoint.push(icon);
  //     healthandsanitization_entrypoint.splice(iconIndexAtAllIcons, 1);
  //   }

  //   this.setState({
  //     selected_health_and_sanitization_entrypoint:
  //       selected_health_and_sanitization_entrypoint,
  //     healthandsanitization_entrypoint: healthandsanitization_entrypoint,
  //     primary_health_and_sanitization_entrypoint:
  //       primary_health_and_sanitization_entrypoint,
  //     actionButton: true,
  //   });
  // };

  // othersHealthAndSafetyRemoveButtonTwo = (icon) => (e) => {
  //   let {
  //     healthandsanitization_facility,
  //     selected_health_and_sanitization_facility,
  //     primary_health_and_sanitization_facility,
  //   } = this.state;

  //   let iconIndexAtAllIcons = healthandsanitization_facility.findIndex(
  //     (icons) => icons._id === icon._id
  //   );
  //   let iconIndexAtSelectedIcons =
  //     selected_health_and_sanitization_facility.findIndex(
  //       (icons) => icons._id === icon._id
  //     );
  //   let iconAtPrimaryIcon =
  //     !isEmpty(primary_health_and_sanitization_facility) &&
  //     primary_health_and_sanitization_facility._id === icon._id
  //       ? true
  //       : false;
  //   if (selected_health_and_sanitization_facility.length === 0) {
  //     selected_health_and_sanitization_facility.push(icon);
  //     healthandsanitization_facility.splice(iconIndexAtAllIcons, 1);
  //     primary_health_and_sanitization_facility = icon;
  //   } else if (iconAtPrimaryIcon) {
  //     selected_health_and_sanitization_facility.splice(
  //       iconIndexAtSelectedIcons,
  //       1
  //     );
  //     healthandsanitization_facility.push(icon);
  //     if (selected_health_and_sanitization_facility.length === 1) {
  //       primary_health_and_sanitization_facility =
  //         selected_health_and_sanitization_facility[0];
  //     } else {
  //       primary_health_and_sanitization_facility = {};
  //     }
  //   } else if (iconIndexAtSelectedIcons === 0 || iconIndexAtSelectedIcons) {
  //     selected_health_and_sanitization_facility.splice(
  //       iconIndexAtSelectedIcons,
  //       1
  //     );
  //     healthandsanitization_facility.push(icon);
  //     if (selected_health_and_sanitization_facility.length === 1) {
  //       primary_health_and_sanitization_facility =
  //         selected_health_and_sanitization_facility[0];
  //     }
  //   } else {
  //     selected_health_and_sanitization_facility.push(icon);
  //     healthandsanitization_facility.splice(iconIndexAtAllIcons, 1);
  //   }

  //   this.setState({
  //     selected_health_and_sanitization_facility:
  //       selected_health_and_sanitization_facility,
  //     healthandsanitization_facility: healthandsanitization_facility,
  //     primary_health_and_sanitization_facility:
  //       primary_health_and_sanitization_facility,
  //     actionButton: true,
  //   });
  // };

  // othersHealthAndSafetyRemoveButtonThree = (icon) => (e) => {
  //   let {
  //     healthandsanitization_employees,
  //     selected_health_and_sanitization_employees,
  //     primary_health_and_sanitization_employees,
  //   } = this.state;

  //   let iconIndexAtAllIcons = healthandsanitization_employees.findIndex(
  //     (icons) => icons._id === icon._id
  //   );
  //   let iconIndexAtSelectedIcons =
  //     selected_health_and_sanitization_employees.findIndex(
  //       (icons) => icons._id === icon._id
  //     );
  //   let iconAtPrimaryIcon =
  //     !isEmpty(primary_health_and_sanitization_employees) &&
  //     primary_health_and_sanitization_employees._id === icon._id
  //       ? true
  //       : false;
  //   if (selected_health_and_sanitization_employees.length === 0) {
  //     selected_health_and_sanitization_employees.push(icon);
  //     healthandsanitization_employees.splice(iconIndexAtAllIcons, 1);
  //     primary_health_and_sanitization_employees = icon;
  //   } else if (iconAtPrimaryIcon) {
  //     selected_health_and_sanitization_employees.splice(
  //       iconIndexAtSelectedIcons,
  //       1
  //     );
  //     healthandsanitization_employees.push(icon);
  //     if (selected_health_and_sanitization_employees.length === 1) {
  //       primary_health_and_sanitization_employees =
  //         selected_health_and_sanitization_employees[0];
  //     } else {
  //       primary_health_and_sanitization_employees = {};
  //     }
  //   } else if (iconIndexAtSelectedIcons === 0 || iconIndexAtSelectedIcons) {
  //     selected_health_and_sanitization_employees.splice(
  //       iconIndexAtSelectedIcons,
  //       1
  //     );
  //     healthandsanitization_employees.push(icon);
  //     if (selected_health_and_sanitization_employees.length === 1) {
  //       primary_health_and_sanitization_employees =
  //         selected_health_and_sanitization_employees[0];
  //     }
  //   } else {
  //     selected_health_and_sanitization_employees.push(icon);
  //     healthandsanitization_employees.splice(iconIndexAtAllIcons, 1);
  //   }

  //   this.setState({
  //     selected_health_and_sanitization_employees:
  //       selected_health_and_sanitization_employees,
  //     healthandsanitization_employees: healthandsanitization_employees,
  //     primary_health_and_sanitization_employees:
  //       primary_health_and_sanitization_employees,
  //     actionButton: true,
  //   });
  // };

  // othersHealthAndSafetyRemoveButtonFour = (icon) => (e) => {
  //   let {
  //     healthandsanitization_food_handling,
  //     selected_health_and_sanitization_food_handling,
  //     primary_health_and_sanitization_food_handling,
  //   } = this.state;

  //   let iconIndexAtAllIcons = healthandsanitization_food_handling.findIndex(
  //     (icons) => icons._id === icon._id
  //   );
  //   let iconIndexAtSelectedIcons =
  //     selected_health_and_sanitization_food_handling.findIndex(
  //       (icons) => icons._id === icon._id
  //     );
  //   let iconAtPrimaryIcon =
  //     !isEmpty(primary_health_and_sanitization_food_handling) &&
  //     primary_health_and_sanitization_food_handling._id === icon._id
  //       ? true
  //       : false;
  //   if (selected_health_and_sanitization_food_handling.length === 0) {
  //     selected_health_and_sanitization_food_handling.push(icon);
  //     healthandsanitization_food_handling.splice(iconIndexAtAllIcons, 1);
  //     primary_health_and_sanitization_food_handling = icon;
  //   } else if (iconAtPrimaryIcon) {
  //     selected_health_and_sanitization_food_handling.splice(
  //       iconIndexAtSelectedIcons,
  //       1
  //     );
  //     healthandsanitization_food_handling.push(icon);
  //     if (selected_health_and_sanitization_food_handling.length === 1) {
  //       primary_health_and_sanitization_food_handling =
  //         selected_health_and_sanitization_food_handling[0];
  //     } else {
  //       primary_health_and_sanitization_food_handling = {};
  //     }
  //   } else if (iconIndexAtSelectedIcons === 0 || iconIndexAtSelectedIcons) {
  //     selected_health_and_sanitization_food_handling.splice(
  //       iconIndexAtSelectedIcons,
  //       1
  //     );
  //     healthandsanitization_food_handling.push(icon);
  //     if (selected_health_and_sanitization_food_handling.length === 1) {
  //       primary_health_and_sanitization_food_handling =
  //         selected_health_and_sanitization_food_handling[0];
  //     }
  //   } else {
  //     selected_health_and_sanitization_food_handling.push(icon);
  //     healthandsanitization_food_handling.splice(iconIndexAtAllIcons, 1);
  //   }

  //   this.setState({
  //     selected_health_and_sanitization_food_handling:
  //       selected_health_and_sanitization_food_handling,
  //     healthandsanitization_food_handling: healthandsanitization_food_handling,
  //     primary_health_and_sanitization_food_handling:
  //       primary_health_and_sanitization_food_handling,
  //     actionButton: true,
  //   });
  // };

  // othersHealthAndSafetyRemoveButtonFive = (icon) => (e) => {
  //   let {
  //     healthandsanitization_health_safety,
  //     selected_health_and_sanitization_health_safety,
  //     primary_health_and_sanitization_health_safety,
  //   } = this.state;

  //   let iconIndexAtAllIcons = healthandsanitization_health_safety.findIndex(
  //     (icons) => icons._id === icon._id
  //   );
  //   let iconIndexAtSelectedIcons =
  //     selected_health_and_sanitization_health_safety.findIndex(
  //       (icons) => icons._id === icon._id
  //     );
  //   let iconAtPrimaryIcon =
  //     !isEmpty(primary_health_and_sanitization_health_safety) &&
  //     primary_health_and_sanitization_health_safety._id === icon._id
  //       ? true
  //       : false;
  //   if (selected_health_and_sanitization_health_safety.length === 0) {
  //     selected_health_and_sanitization_health_safety.push(icon);
  //     healthandsanitization_health_safety.splice(iconIndexAtAllIcons, 1);
  //     primary_health_and_sanitization_health_safety = icon;
  //   } else if (iconAtPrimaryIcon) {
  //     selected_health_and_sanitization_health_safety.splice(
  //       iconIndexAtSelectedIcons,
  //       1
  //     );
  //     healthandsanitization_health_safety.push(icon);
  //     if (selected_health_and_sanitization_health_safety.length === 1) {
  //       primary_health_and_sanitization_health_safety =
  //         selected_health_and_sanitization_health_safety[0];
  //     } else {
  //       primary_health_and_sanitization_health_safety = {};
  //     }
  //   } else if (iconIndexAtSelectedIcons === 0 || iconIndexAtSelectedIcons) {
  //     selected_health_and_sanitization_health_safety.splice(
  //       iconIndexAtSelectedIcons,
  //       1
  //     );
  //     healthandsanitization_health_safety.push(icon);
  //     if (selected_health_and_sanitization_health_safety.length === 1) {
  //       primary_health_and_sanitization_health_safety =
  //         selected_health_and_sanitization_health_safety[0];
  //     }
  //   } else {
  //     selected_health_and_sanitization_health_safety.push(icon);
  //     healthandsanitization_health_safety.splice(iconIndexAtAllIcons, 1);
  //   }
  //   this.setState({
  //     selected_health_and_sanitization_health_safety:
  //       selected_health_and_sanitization_health_safety,
  //     healthandsanitization_health_safety: healthandsanitization_health_safety,
  //     primary_health_and_sanitization_health_safety:
  //       primary_health_and_sanitization_health_safety,
  //     actionButton: true,
  //   });
  // };

  onHandleSubmit = (e) => {
    e.preventDefault();
    let onboarding = this.props?.editDataAction
      ? this.props?.editData
      : this.props?.onboardingData;
    if (
      onboarding &&
      (onboarding && onboarding?.discription) !== "" &&
      (onboarding && onboarding?.discription) !== undefined &&
      (onboarding && onboarding?.discription) !== null
    ) {
      const formData = {
        healthAndSanitizeSwitchValue: this.state.healthAndSanitizeSwitchValue,
        healthAndSanitizeProtocolCheck:
          this.state.healthAndSanitizeProtocolCheck,
        selectedPage: this.state.selectedPage,
        selected_health_and_sanitization_entrypoint:
          this.state.selected_health_and_sanitization_entrypoint,
        selected_health_and_sanitization_facility:
          this.state.selected_health_and_sanitization_facility,
        selected_health_and_sanitization_employees:
          this.state.selected_health_and_sanitization_employees,
        selected_health_and_sanitization_food_handling:
          this.state.selected_health_and_sanitization_food_handling,
        selected_health_and_sanitization_health_safety:
          this.state.selected_health_and_sanitization_health_safety,
        primary_health_and_sanitization_entrypoint:
          this.state.primary_health_and_sanitization_entrypoint,
        primary_health_and_sanitization_facility:
          this.state.primary_health_and_sanitization_facility,
        primary_health_and_sanitization_employees:
          this.state.primary_health_and_sanitization_employees,
        primary_health_and_sanitization_food_handling:
          this.state.primary_health_and_sanitization_food_handling,
        primary_health_and_sanitization_health_safety:
          this.state.primary_health_and_sanitization_health_safety,
        discription: this.state.discription,
        vendor_id: onboarding?.vendor_id,
        id: onboarding?._id,
        selectedPage: 1,
      };
      this.props.superadmin_create_and_update_restaurant(formData);
      this.props.history.push(
        this.props?.editDataAction
          ? "/admin_edit_cuisinesetup"
          : "/addvendorcuisinesetup"
      );
    } else {
      const formData = {
        healthAndSanitizeSwitchValue: this.state.healthAndSanitizeSwitchValue,
        healthAndSanitizeProtocolCheck:
          this.state.healthAndSanitizeProtocolCheck,
        selectedPage: this.state.selectedPage,
        selected_health_and_sanitization_entrypoint:
          this.state.selected_health_and_sanitization_entrypoint,
        selected_health_and_sanitization_facility:
          this.state.selected_health_and_sanitization_facility,
        selected_health_and_sanitization_employees:
          this.state.selected_health_and_sanitization_employees,
        selected_health_and_sanitization_food_handling:
          this.state.selected_health_and_sanitization_food_handling,
        selected_health_and_sanitization_health_safety:
          this.state.selected_health_and_sanitization_health_safety,
        primary_health_and_sanitization_entrypoint:
          this.state.primary_health_and_sanitization_entrypoint,
        primary_health_and_sanitization_facility:
          this.state.primary_health_and_sanitization_facility,
        primary_health_and_sanitization_employees:
          this.state.primary_health_and_sanitization_employees,
        primary_health_and_sanitization_food_handling:
          this.state.primary_health_and_sanitization_food_handling,
        primary_health_and_sanitization_health_safety:
          this.state.primary_health_and_sanitization_health_safety,
        discription: this.state.discription,
        vendor_id: onboarding?.vendor_id,
        id: onboarding?._id,
        page_completed_till: 16,
        selectedPage: 1,
      };
      this.props.superadmin_create_and_update_restaurant(formData);
      this.props.history.push(
        this.props?.editDataAction
          ? "/admin_edit_cuisinesetup"
          : "/addvendorcuisinesetup"
      );
    }
  };

  renderHealthsenitationFields = () => {
    const {
      // healthAndSanitizeSwitchValue,
      errors,
      actionButton,
      healthAndSanitizeEntryPointCheck,
      healthAndSanitizeFacilityCheck,
      healthAndSanitizeServicesCheck,
      healthAndSanitizeEmployeesCheck,
      healthAndSanitizePracticesCheck,
      healthAndSanitizeProtocolCheck,
    } = this.state;
    return (
      <React.Fragment>
        <div className="restaurant_type_onboarding_main">
          <div>
            <div className="cuisine-main">
              {this.state.selectedPage === 1 ? (
                <HealthAndSenitationOthers
                  bigText="What are the Hygiene and Sanitation options available at Entry Point?"
                  smallText="Please select items from the list below"
                  primaryBigText="Out of the selections below, which one is primary?"
                  primarySmallText="Select only one of the options below as a default - this is shown to the user."
                  entryPointCheck={healthAndSanitizeEntryPointCheck}
                  entryPointCheckHandler={this.entryPointCheckSwitchValue}
                  otherHealth={this.state.healthandsanitization_entrypoint}
                  selectedOtherHealth={
                    this.state.selected_health_and_sanitization_entrypoint
                  }
                  primaryOtherHealth={
                    this.state.primary_health_and_sanitization_entrypoint
                  }
                  onRestaurantSelectorArraySelector={
                    this.othersHealthAndSafetyHandler
                  }
                  onRestaurantsPrimarySelector={
                    this.othersHealthAndSafetyPrimarySelector
                  }
                  removeButton={this.othersHealthAndSafetyRemoveButton}
                  onBackButtonClick={this.onEnteryPointBackButton}
                  onNextButtonClick={
                    // actionButton === false
                    //   ? this.whithOutEnteryPointNextButton
                    //   :
                    this.onEnteryPointNextButton
                  }
                />
              ) : null || this.state.selectedPage === 2 ? (
                <HealthAndSenitationOthersTwo
                  bigText="What are the Hygiene and Sanitation options available Inside the Facility"
                  smallText="Please select items from the list below"
                  primaryBigText="Out of the selections below, which one is primary?"
                  primarySmallText="Select only one of the options below as a default - this is shown to the user."
                  facilityCheck={healthAndSanitizeFacilityCheck}
                  facilityCheckHandler={this.facilityCheckSwitchValue}
                  otherHealth={this.state.healthandsanitization_facility}
                  selectedOtherHealth={
                    this.state.selected_health_and_sanitization_facility
                  }
                  primaryOtherHealth={
                    this.state.primary_health_and_sanitization_facility
                  }
                  onRestaurantSelectorArraySelector={
                    this.othersHealthAndSafetyHandlerTwo
                  }
                  onRestaurantsPrimarySelector={
                    this.othersHealthAndSafetyPrimarySelectorTwo
                  }
                  removeButton={this.othersHealthAndSafetyRemoveButtonTwo}
                  onBackButtonTwoClick={this.onInsideFacilityBackButton}
                  onNextButtonTwoClick={
                    // actionButton === false
                    //   ? this.whithOutInsideFacilityNextButton
                    //   :
                    this.onInsideFacilityNextButton
                  }
                />
              ) : null || this.state.selectedPage === 3 ? (
                <HealthAndSenitationOthersThree
                  bigText="What are the Hygiene and Sanitation options available for food handling practices"
                  smallText="Please select items from the list below"
                  primaryBigText="Out of the selections below, which one is primary?"
                  primarySmallText="Select only one of the options below as a default - this is shown to the user."
                  employeesCheck={healthAndSanitizeEmployeesCheck}
                  employeesCheckHandler={this.employeesCheckSwitchValue}
                  otherHealth={this.state.healthandsanitization_employees}
                  selectedOtherHealth={
                    this.state.selected_health_and_sanitization_employees
                  }
                  primaryOtherHealth={
                    this.state.primary_health_and_sanitization_employees
                  }
                  onRestaurantSelectorArraySelector={
                    this.othersHealthAndSafetyHandlerThree
                  }
                  onRestaurantsPrimarySelector={
                    this.othersHealthAndSafetyPrimarySelectorThree
                  }
                  removeButton={this.othersHealthAndSafetyRemoveButtonThree}
                  onBackButtonThreeClick={this.onEmployeesBackButton}
                  onNextButtonThreeClick={
                    // actionButton === false
                    //   ? this.whithOutEmployeesNextButton
                    //   :
                    this.onEmployeesNextButton
                  }
                />
              ) : null || this.state.selectedPage === 4 ? (
                <HealthAndSenitationOthersFour
                  bigText="What are the Hygiene and Sanitation options available for Food Handling practices"
                  smallText="Please select items from the list below"
                  primaryBigText="Out of the selections below, which one is primary?"
                  primarySmallText="Select only one of the options below as a default - this is shown to the user."
                  servicesCheck={healthAndSanitizeServicesCheck}
                  servicesCheckHandler={this.servicesCheckSwitchValue}
                  otherHealth={this.state.healthandsanitization_food_handling}
                  selectedOtherHealth={
                    this.state.selected_health_and_sanitization_food_handling
                  }
                  primaryOtherHealth={
                    this.state.primary_health_and_sanitization_food_handling
                  }
                  onRestaurantSelectorArraySelector={
                    this.othersHealthAndSafetyHandlerFour
                  }
                  onRestaurantsPrimarySelector={
                    this.othersHealthAndSafetyPrimarySelectorFour
                  }
                  removeButton={this.othersHealthAndSafetyRemoveButtonFour}
                  onBackButtonFourClick={this.onFoodHandlingBackButton}
                  onNextButtonFourClick={
                    // actionButton === false
                    //   ? this.whithOutFoodHandlingNextButton
                    //   :
                    this.onFoodHandlingNextButton
                  }
                />
              ) : null || this.state.selectedPage === 5 ? (
                <HealthAndSenitationOthersFive
                  bigText="Following are other Health and Safety?"
                  smallText="Please select items from the list below"
                  primaryBigText="Out of the selections below, which one is primary?"
                  primarySmallText="Select only one of the options below as a default - this is shown to the user."
                  practiceCheck={healthAndSanitizePracticesCheck}
                  practiceCheckHandler={this.practicesCheckSwitchValue}
                  otherHealth={this.state.healthandsanitization_health_safety}
                  selectedOtherHealth={
                    this.state.selected_health_and_sanitization_health_safety
                  }
                  primaryOtherHealth={
                    this.state.primary_health_and_sanitization_health_safety
                  }
                  onRestaurantSelectorArraySelector={
                    this.othersHealthAndSafetyHandlerFive
                  }
                  onRestaurantsPrimarySelector={
                    this.othersHealthAndSafetyPrimarySelectorFive
                  }
                  removeButton={this.othersHealthAndSafetyRemoveButtonFive}
                  onBackButtonFiveClick={this.onHealthSafetyBackButton}
                  onNextButtonFiveClick={
                    actionButton === false
                      ? this.whithOutHealthSafetyNextButton
                      : this.onHealthSafetyNextButton
                  }
                />
              ) : null || this.state.selectedPage === 6 ? (
                <HealthAndSenitationProtocol
                  protocolCheck={healthAndSanitizeProtocolCheck}
                  protocolCheckHandler={this.protocolCheckSwitchValue}
                  onChange={this.onChange}
                  name="discription"
                  onFocusOut={this.onFocusOut}
                  discriptionProtocol={this.state.discription}
                  errors={
                    this.state.discription <= 0 ? errors.discription : null
                  }
                  onBackButtonClick={this.onDiscriptionProtocolBackButton}
                  // onClick={
                  //   actionButton === false
                  //     ? this.whithOutDiscriptionProtocolNextButton
                  //     : null
                  // }
                  // buttonType={actionButton === false ? "button" : "submit"}
                  buttonType="submit"
                />
              ) : null}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  };

  handleFormShow = () => {
    this.setState({ formShow: true, healthAndSanitizeSwitchValue: false });
  };
  handleFormHide = () => {
    this.setState({ formShow: false });
  };

  render() {
    if (this.state.loader) {
      return <AmealioLoader />;
    }
    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation displayLink={1} />
            </div>
            <div className="super-admin-right-side-panel">
              <HomeReusableTopBarNavigation />
              <div className="col-6 pl-5 pr-5">
                <div className="super_admin_add_vendor mb-4">
                  <h5 className="main_header_text">
                    {this.props?.editDataAction ? "Edit" : "Add"} Vendor
                  </h5>
                  <h4 className="font_20_m">Step : 16</h4>
                  <h4 className="font_20_m c_red mt-2 mb-1">
                    Health and Sanitation
                  </h4>
                  <hr className="hr_line" />
                </div>
                <TopTextReusableComponent
                  headingText="Health and Sanitation"
                  headingParagraph="( Please enter information about the Hygiene and Sanitation efforts and protocol )"
                />
                {this.state.healthAndSanitizeSwitchValue === true ? (
                  <Form noValidate onSubmit={this.onHandleSubmit}>
                    {this.renderHealthsenitationFields()}
                  </Form>
                ) : (
                  <SuperAdminHASHomeScreen
                    onClickHome={this.onClickHomeButton}
                    handleFormHide={this.handleFormHide}
                  />
                )}
                {/* <Form noValidate onSubmit={this.onHandleSubmit}>
                  {this.renderHealthsenitationFields()}
                </Form> */}
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

SuperAdminVendorHealthAndSenitation.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboardingData: state.superAdminOnboarding.restaurantDetails,
  editData: state?.adminAllVendorsInfo?.superAdminMerchantEditInfo,
  editDataAction:
    state?.adminAllVendorsInfo?.superAdminMerchantEditType?.editData,
  health_entry_point: state.category.health_entry_point,
  health_inside_facility: state.category.health_inside_facility,
  health_employees: state.category.health_employees,
  health_handling: state.category.health_handling,
  heath_and_safety: state.category.heath_and_safety,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  superadmin_create_and_update_restaurant,
})(withRouter(SuperAdminVendorHealthAndSenitation));
